/**
 * Pushes a Tag Manager custom event. The live container reads these names
 * from the data layer. `gtag('event')` is not used: the page stub has no
 * measurement id, and the container does not forward that command.
 */
type WebsiteEventParam = string | number | boolean | null;

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

export type PricingEventItem = {
  item_id: string;
  item_name: string;
  price: number;
  quantity: number;
  item_category?: string;
  item_category2?: string;
};

const push = (message: unknown): void => {
  if (typeof window === 'undefined') return;
  const dataLayer = (window.dataLayer = window.dataLayer || []);
  dataLayer.push(message);
};

export const trackWebsiteEvent = (
  eventName: string,
  params: Record<string, WebsiteEventParam | undefined> = {}
): void => {
  const payload: Record<string, unknown> = { event: eventName };
  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (value !== undefined) payload[key] = value;
  });
  push(payload);
};

/**
 * Clears the previous ecommerce object, then pushes the event.
 * Tag Manager reads `ecommerce` from the data layer for these two events.
 */
export const trackEcommerceEvent = (
  eventName: 'view_item_list' | 'select_item',
  params: {
    locale: string;
    cta_location?: string | null;
    items: PricingEventItem[];
  }
): void => {
  push({ ecommerce: null });
  push({
    event: eventName,
    locale: params.locale,
    cta_location: params.cta_location ?? null,
    ecommerce: {
      currency: 'USD',
      item_list_name: 'pricing',
      items: params.items,
    },
  });
};
